<app-step-wrapper>
  <app-step-columns>
    <div left>
      <h1 [appLocalizedText]="title$ | async"></h1>
      <p [appLocalizedText]="subtitle$ | async"></p>
    </div>
    <div right>
      <app-choice-button
        *ngFor="let whereToInstallChargerItem of whereToInstallChargerItems$ | async"
        [icon]="whereToInstallChargerItem.icon"
        [caption]="whereToInstallChargerItem.caption | translate"
        [attr.data-test]="whereToInstallChargerItem.value"
        (click)="saveStepData(whereToInstallChargerItem.value)"
        [active]="whereToInstallChargerItem.value === whereToInstallChargerSelection">
      </app-choice-button>
    </div>
  </app-step-columns>
</app-step-wrapper>
